import { ProjectionLike } from "ol/proj";

export const ProjectionConfig = {
    backendFormat: "EPSG:4326",
    displayFormat: "EPSG:3857",
} satisfies Record<string, ProjectionLike>;
